export default __webpack_public_path__ + "static/media/egg.4d911d05.jpg";